import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';

const FinanceContractList = ({
  getApprovedSaleListing,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
}) => {
  const headers = [
    'Lead Number',
    'Site Number',
    'Client Name',
    'Created By',
    'Lead Category',
    'Assigned To',
    'Assigned To (Installation)',
    'Assigned To (Brand Activation)',
    'Creation On',
    'Status',
    'Ops Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales('post-sales-corporate');
      } else if (teamId && teamId === 9) {
        setActivePostSales('post-sales-supply');
      } else if (teamId && teamId === 8) {
        setActivePostSales('post-sales-apartment');
      } else {
        setActivePostSales('post-sales-b2b-alliance');
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getApprovedSaleListing !== null) {
      (async () => {
        setIsLoading(true);
        await getApprovedSaleListing(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getApprovedSaleListing]);

  useEffect(() => {
    const tableData = [
      'id',
      'lead_no',
      'site_no',
      'client_name',
      'created_by',
      'lead_category',
      'assigned_to',
      'assigned_to_installation',
      'assigned_to_ba',
      'created_at',
      'status',
      'ops_status',
    ];

    // const actions = [
    //   { name: 'View Details', link: '/dashboard/lead-details' },
    //   // { name: "Request PI", link: "/dashboard/followUp" },
    //   { name: 'View Follow Up', link: '/dashboard/followUp' },
    //   { name: 'View POC', link: `/dashboard/viewPoc` },
    // ];

    if (postSalesList.resultSets !== undefined && Object.keys(postSalesList.resultSets).length > 0) {
      const data = postSalesList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          // {
          //   Action: [
          //     { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
          //     // { name: "Request PI", link: "/dashboard/followUp" },
          //     // { name: 'View Follow Up', link: '/dashboard/followUp' },
          //     // { name: 'View POC', link: `/dashboard/viewPoc` },
          //   ],
          // },
          (parseInt(isRoleId) === 11 || parseInt(isRoleId) === 12) ? {
            Action: [
              { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id }
            ]
          } :
          element.status == "Approval Pending" ? 
            element.lead_type_id == 1 
            ? {
              Action: [
                { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
                {
                  name: 'Site Repository',
                  link: '/dashboard/site-repository-finance/'+element.comm_id
                },
                {
                  name: 'Client Address Mapping',
                  link: '/dashboard/client-contract-mapping/'+element.comm_id
                }
              ]
              }  
            : {
              Action: [
                { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
                {
                  name: 'Site Repository',
                  link: '/dashboard/site-repository-finance/'+element.comm_id,
                },
                {
                  name: 'Client Address Mapping',
                  link: '/dashboard/client-contract-mapping/'+element.comm_id
                }
              ]
            } 
          : {
            Action: [
              { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
              {
                name: 'Site Repository',
                link: '/dashboard/site-repository-finance/'+element.comm_id,
              },
              {
                name: 'Map Client Address',
                link: '/dashboard/client-contract-mapping/'+element.comm_id
              },
              {
                name: 'Client-Business Details',
                link: '/dashboard/client-business/'+element.comm_id
              },
              {
                name: 'Change Client',
                link: '/dashboard/client-change/'+element.comm_id
              },
              {
                name: 'Change Business Address',
                link: '/dashboard/business-change/'+element.comm_id
              }
            ]
          },
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getApprovedSaleListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
        {/* <a
          href=""
          className="btn btn-primary d-none d-md-inline-block"
          data-toggle="modal"
          data-target="#bulkAssignment"
        >
          Bulk Assignment <img src={ArrowRight} alt=""></img>
        </a>
        <a href="" className="filter-hamburger btn btn-transparent">
          <img src={Filter} alt=""></img>
          Show Filters
        </a> */}
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getApprovedSaleListing(filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.approvedSalesLeadListing}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={postSalesList && postSalesList.resultSets}
        pageCount={pageCount}
        srNo={postSalesList?.from}
        onPageChange={onPageChange}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'5'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        filterFinanceSalesListing
      />

      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default FinanceContractList;
